import * as React from 'react'

function SvgCameraCrossed(props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={svgRef}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.567 1.204A.712.712 0 0014.49.178a.766.766 0 00-1.058.073l-2.8 3.133a1.376 1.376 0 00-.435-.07H1.407c-.37 0-.727.149-.992.418A1.46 1.46 0 000 4.755v7.46c0 .385.15.753.415 1.023.265.269.622.418.992.418h.045l-1.019 1.14a.712.712 0 00.076 1.026.766.766 0 001.058-.073l1.87-2.093h6.76c.37 0 .728-.149.992-.418a1.46 1.46 0 00.415-1.024v-.581l2.13 1.69a1.376 1.376 0 001.472.156c.236-.117.436-.3.577-.528.14-.229.216-.494.217-.765V4.784c0-.272-.076-.537-.217-.765a1.419 1.419 0 00-.576-.528 1.377 1.377 0 00-1.473.156l-2.13 1.69v-.582c0-.074-.005-.147-.016-.219l2.979-3.332zM9.452 4.706H1.407a.063.063 0 00-.045.018.045.045 0 00-.014.031v7.46c0 .01.004.02.014.031.01.01.026.018.045.018h1.29l6.755-7.558zm-4.77 7.558l5.574-6.238v6.188c0 .01-.003.022-.013.032a.063.063 0 01-.045.018H4.68zm9.94-7.52a.066.066 0 00-.069.007l-.001.001-2.948 2.335v2.797l2.949 2.364a.065.065 0 00.07.007.055.055 0 00.022-.02.043.043 0 00.007-.022V4.786a.043.043 0 00-.007-.022.056.056 0 00-.023-.02z"
        fill={props.color || 'currentColor'}
      />
    </svg>
  )
}

const ForwardRef = React.forwardRef(SvgCameraCrossed)
const MemoForwardRef = React.memo(ForwardRef)
export default MemoForwardRef
